module.exports = __webpack_public_path__ + "img/csv.0cad7b0a.svg";